import React from "react";

type Props = {
  errorMessages: string[];
};

const OrderVerificationErrorMessages: React.FC<Props> = ({ errorMessages = [] }) => {
  if (errorMessages.length === 0) {
    return null;
  }

  return (
    <div className="btn-wrap btn-wrap--line">
      <div />
      <span className="form-error">
        {errorMessages.map(message => (
          <React.Fragment key={message}>
            <>{message}</>
            <br />
          </React.Fragment>
        ))}
      </span>
    </div>
  );
};

export default OrderVerificationErrorMessages;
